import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);


// ===============================================================
// FORM
// ===============================================================

const form = document.querySelector("form");
const formElements = form.querySelectorAll('input[type="text"], input[type="hidden"], input[type="radio"], input[type="checkbox"], textarea, select');

// const hideConfirmElements = document.querySelectorAll('.c-form-confirm__hidden');
// const showConfirmElements = document.querySelectorAll('.c-form-confirm__show');

const btnConfirm = document.querySelector('.c-btn-confirm');
const btnReturn = document.querySelector('.c-btn-return');
const btnSubmit = document.querySelector('.c-btn-submit');

function getRequestUrl() {
  const formName = form.dataset.form;
  var url = new URL(window.location.href);
  return url.origin + "/mailer/" + formName + "/validation.php";
  // return "../../test/mailer/" +formName+ "/validation.php";
}

function validation() {
  const formData = new FormData(form);
  formData.append('confirmFlag', true)

  fetch( getRequestUrl(), {method: 'POST', body: formData} )
  .then(response => response.json())
  .then(json => {
    console.log(json);
    
    if(json.is_success) {
      confirm(json);
    }
    else {
      error(json);
    }
  })
}

function error(data) {
  const json = data;
  var positionY = null;

  removeText();
  
  //エラーメッセージ表示
  Object.keys(json.errors).forEach((key, index) => {
    var data = json.errors[key];
    const errorField = document.querySelector('.field-'+data.classname);
    var addElem = document.createElement('p');
    addElem.innerText = data.message;
    addElem.classList.add('error_message');
    errorField.parentNode.insertBefore(addElem, errorField.nextElementSibling);
  });

  //最初のエラー
  const firstError = document.querySelectorAll('.error_message');
  positionY = firstError[0].parentNode.getBoundingClientRect().top + window.pageYOffset;
  const header = document.querySelector(".l-header");
  var offset = header.clientHeight;
  gsap.to(window, { duration: 0.3, scrollTo: { y: positionY - offset, autoKill: false}, ease: 'power2' });
}

function confirm(data) {
  const json = data;
  document.body.classList.remove('p-form__entry');
  document.body.classList.add('p-form__confirm');
  removeText();
  //非表示
  
  //バリュー取得 表示
  formElements.forEach( elm => {
    if(elm.type === "radio") {
      let radioBtn = elm.closest('.field-radio-btn');
      if(elm.checked) {
        radioBtn.classList.add('is-checked');
      }
      else {
        radioBtn.classList.remove('is-checked');
      }
    }
    else if(elm.type === "checkbox") {
      let checkBtn = elm.closest('.field');
      if(elm.checked) {
        checkBtn.classList.add('is-checked');
      }
      else {
        checkBtn.classList.remove('is-checked');
      }
    }
    else {
      const dd = elm.closest('dd');
      if(dd){
        const field = dd.querySelector('.field');
        var newEle = document.createElement('p');
        console.log(elm.type == "radio")      
        if(elm.value != "") {
          newEle.innerText = htmlspecialchars(elm.value);
          newEle.classList.add('field-value');
          field.appendChild(newEle,);
        }
      }
    }
  });

  //トークンセット
  document.querySelector('[name="csr_token"]').value = json.token;
  //ACTIONセット
  form.setAttribute("action", getRequestUrl());

  gsap.to(window, { duration: 0.3, scrollTo: { y: 0, autoKill: false}, ease: 'power2' });
}

function edit() {
  removeText();
  document.body.classList.add('p-form__entry');
  document.body.classList.remove('p-form__confirm');

  gsap.to(window, { duration: 0.3, scrollTo: { y: 0, autoKill: false}, ease: 'power2' });
}


function removeText() {
  const errorMessages = document.querySelectorAll(".error_message");
  if(errorMessages) {
    errorMessages.forEach( message => {
      message.remove();
    });
  }
  const fieldValues = form.querySelectorAll('.field-value');
  if(fieldValues) {
    fieldValues.forEach( elm => {
      elm.remove();
    });
  }
}

function htmlspecialchars(str) {
  return (str + "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

// イベント
btnConfirm.addEventListener("click", function(e){
  validation();
  e.preventDefault();
});
btnReturn.addEventListener("click", function(e){
  edit();
  e.preventDefault();
});

const agreeCheckbox = document.getElementById("pp");
agreeCheckbox.addEventListener("click", function(e){
  if (agreeCheckbox.checked === true) {
    btnConfirm.disabled = false;
  }
  else {
    btnConfirm.disabled = true;
  }
});
